export default "__VITE_ASSET__CSzjLM7k__"